import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { translate } from "react-translate";
import PracticeOrdersList from 'components/PracticeOrders/PracticeOrdersList';

const PracticeOrders = (props) => {
  const {t} = props;
  
  return (
    <div className='content user-manual'>
      <Card>
        <CardHeader>
          <h5 className="title">{t("title-header")}</h5>
        </CardHeader>
        <CardBody>
          <PracticeOrdersList />
        </CardBody>
      </Card>
    </div>
  );
};

export default translate("practice-orders")(PracticeOrders);
